/* eslint-disable import/no-cycle */
import {
  getMunicipalities,
} from './services/municipality-api';
import {
  getNewSearchRequest,
  postSearchRequest,
  getSearchRequestById,
} from './services/search-requests-api';
import { dataStates, DataSetStatus } from '../../store/shared/DataSetStatusModels';

export const SET_MUNICIPALITIES_LIST = 'searchRequests/SET_MUNICIPALITIES_LIST';
export const SET_SEARCH_REQUEST = 'searchRequests/SET_SEARCH_REQUEST';
export const FETCH_MUNICIPALITIES_LIST = 'searchRequests/FETCH_MUNICIPALITIES_LIST';
export const FETCH_SEARCH_REQUEST = 'searchRequests/FETCH_SEARCH_REQUEST';
export const POST_SEARCH_REQUEST = 'searchRequests/POST_SEARCH_REQUEST';
export const FETCH_SEARCH_REQUEST_BY_ID = 'searchRequests/FETCH_SEARCH_REQUEST_BY_ID';
// export const FETCH_ORDER_BY_ID = 'searchRequests/SET_SEARCH_REQUEST';
// export const FETCH_ORDERS = 'searchRequests/FETCH_ORDERS';
const SET_MUNICIPALITY_DATASET_STATUS = 'searchRequests/SET_MUNICIPALITY_DATASET_STATUS';

export const searchRequestsStore = {
  state: {
    municipalities: null,
    selectedMunicipality: null,
    currentSearchRequest: null,
    municipalityDataSetStatus: new DataSetStatus(),
  },
  mutations: {
    [SET_MUNICIPALITIES_LIST](state, { municipalities }) {
      state.municipalities = municipalities?.sort((a, b) => a.name.localeCompare(b.name));
    },
    [SET_MUNICIPALITY_DATASET_STATUS](state, { status }) {
      state.municipalityDataSetStatus.status = status;
    },
    [SET_SEARCH_REQUEST](state, { payload }) {
      state.currentSearchRequest = payload;
    },
  },
  getters: {
    getMunicipalities: (state) => state.municipalities,
    getSelectedMunicipality: (state) => state.selectedMunicipality,
    getCurrentSearchRequest: (state) => state.currentSearchRequest,
  },
  actions: {
    [FETCH_MUNICIPALITIES_LIST]: async ({ state, commit }) => {
      if (state.municipalityDataSetStatus.status === dataStates.loaded) {
        return state.municipalities;
      }

      if (state.municipalityDataSetStatus.status === dataStates.notSet) {
        commit(SET_MUNICIPALITIES_LIST, { municipalities: null });
        commit(SET_MUNICIPALITY_DATASET_STATUS, { status: dataStates.loading });

        state.municipalityDataSetStatus.dataPromise = getMunicipalities().then((resp) => {
          commit(SET_MUNICIPALITIES_LIST, { municipalities: resp.data });
          commit(SET_MUNICIPALITY_DATASET_STATUS, { status: dataStates.loaded });
          return state.municipalities;
        }).catch((error) => {
          console.error(error);
          commit(SET_MUNICIPALITY_DATASET_STATUS, { status: dataStates.error });
          state.municipalityDataSetStatus.dataPromise.reject('Failed to load the municipalities', error);
          return state.municipalities;
        });

        return state.municipalityDataSetStatus.dataPromise;
      }
      return state.municipalityDataSetStatus.dataPromise;
    },
    [FETCH_SEARCH_REQUEST]: async ({ commit }, payload) => {
      try {
        const requestDate = payload;
        let data = null;
        if (requestDate !== null && requestDate !== 'new') {
          try {
            const resp = await getNewSearchRequest(requestDate);
            // eslint-disable-next-line prefer-destructuring
            data = resp.data[0];
          } catch {
            data = null;
          }
        }
        if (data) {
          commit(SET_SEARCH_REQUEST, { payload: data });
        } else {
          const today = new Date().toISOString().slice(0, 10);
          data = {
            requestDate: today,
            requestUserEmail: '',
            requestUserType: '',
            municipality: '',
            requestor: '',
            firstName: '',
            lastName: '',
            company: '',
            billingAddress: '',
            city: '',
            province: '',
            postalCode: '',
            phoneNumber: '',
            fileNo: '',
            invoiceNumber: '',
            orderNumber: '',
            requestType: 'search',
            totalAmount: 0,
            totalLevy: 0,
            status: 'Inprogress',
            lastUpdatedDate: today,
            lastUpdateUser: '',
            printName: '',
            deleteFlag: false,
            searchRequestDetails: [
              {
                searchRequestDate: today,
                municipality: '',
                city: '',
                municipalityAddress: '',
                lincNumber: '',
                planNumber: '',
                blockNumber: '',
                lotNumber: '',
                meridianNumber: '',
                rangeNumber: '',
                townshipNumber: '',
                sectionNumber: '',
                quarterSection: '',
                legalSubdivision: '',
                atsNonStandardMeridianNumber: '',
                atsNonStandardRangeNumber: '',
                atsNonStandardTownshipNumber: '',
                atsNonStandardLotNumber: '',
                atsNonStandardLotType: '',
                lastUpdateUser: '',
                lastUpdatedDate: today,
                amount: 0,
                levy: 0,
                deleteFlag: false,
                additionalInformation: '',
              },
            ],
          };
          commit(SET_SEARCH_REQUEST, { payload: data });
        }
      } catch (error) {
        console.error('get-search-request_err: ', error);
        throw error;
      }
    },
    [FETCH_SEARCH_REQUEST_BY_ID]: async ({ commit }, payload) => {
      try {
        const requestId = payload;
        const resp = await getSearchRequestById(requestId);
        const data = resp.data[0];
        commit(SET_SEARCH_REQUEST, { payload: data });
      } catch (error) {
        console.error('get-by-id-search-request_err: ', error);
        throw error;
      }
    },
    [POST_SEARCH_REQUEST]: async ({ commit }, payload) => {
      try {
        const { data } = payload;
        const resp = await postSearchRequest(data);
        commit(SET_SEARCH_REQUEST, { payload: resp.data });
        // return resp.data;
      } catch (error) {
        console.error('post-search-request_err: ', error);
        throw error;
      }
    },
  },
};
